(function () {
  'use strict';

  if (window.HushCheckoutHandoff) return;

  // Cart reservations were removed. Confirm the current Shopify cart, then
  // continue through native checkout without a third-party service dependency.
  var SHOP_DOMAIN = 'mxe15d-nx.myshopify.com';
  var REFILL_PLAN_ID = '8044838997';
  var TIMEOUT_MS = 30000;
  var active = null;

  function handoffError(message, code) {
    var error = new Error(message);
    error.code = code || 'CHECKOUT_HANDOFF_FAILED';
    error.hushCheckoutHandoff = true;
    return error;
  }

  function checkActive(run) {
    if (run.cancelled) throw handoffError('Checkout took too long. Please view your cart to continue.', 'CHECKOUT_HANDOFF_TIMEOUT');
  }

  function getConfiguration() {
    if (!window.Shopify || window.Shopify.shop !== SHOP_DOMAIN) {
      throw handoffError('We couldn’t prepare checkout. Please view your cart to continue.', 'CHECKOUT_ROUTE_UNAVAILABLE');
    }
    var storefrontRoot = window.Shopify.routes && window.Shopify.routes.root || '/';
    var root;
    try { root = new URL(storefrontRoot, window.location.origin); }
    catch (_) { throw handoffError('We couldn’t prepare checkout. Please view your cart to continue.', 'CHECKOUT_ROUTE_UNAVAILABLE'); }
    if (root.origin !== window.location.origin || root.username || root.password || root.search || root.hash || !root.pathname.endsWith('/')) {
      throw handoffError('We couldn’t prepare checkout. Please view your cart to continue.', 'CHECKOUT_ROUTE_UNAVAILABLE');
    }
    return {
      cartUrl: new URL('cart.js', root).href,
      checkoutUrl: new URL('checkout', root).href
    };
  }

  function variantId(value) {
    var result = String(value == null ? '' : value);
    return /^\d+$/.test(result) && Number.isSafeInteger(Number(result)) && Number(result) > 0 ? result : null;
  }

  function cartDetails(cart, expectedSelection) {
    if (!cart || typeof cart.token !== 'string' || !cart.token || !Array.isArray(cart.items) || !cart.items.length) {
      throw handoffError('We couldn’t confirm your cart. Please view your cart to continue.', 'CART_CONFIRMATION_FAILED');
    }
    var planQuantities = Object.create(null);
    var quantity = 0;
    cart.items.forEach(function (item) {
      if (!item || typeof item !== 'object') {
        throw handoffError('We couldn’t confirm your cart. Please view your cart to continue.', 'CART_CONFIRMATION_FAILED');
      }
      var id = variantId(item.variant_id || item.id);
      var count = item.quantity;
      if (!id || !Number.isSafeInteger(count) || count <= 0) {
        throw handoffError('We couldn’t confirm your cart. Please view your cart to continue.', 'CART_CONFIRMATION_FAILED');
      }
      var allocation = item.selling_plan_allocation;
      var plan = allocation && allocation.selling_plan && allocation.selling_plan.id;
      var planId = plan == null ? '' : variantId(plan);
      if (allocation && !planId) {
        throw handoffError('We couldn’t confirm your refill selection. Please view your cart to continue.', 'CART_CONFIRMATION_FAILED');
      }
      planQuantities[id + ':' + planId] = (planQuantities[id + ':' + planId] || 0) + count;
      quantity += count;
    });
    if (!Number.isSafeInteger(quantity) || cart.item_count != null && cart.item_count !== quantity) {
      throw handoffError('We couldn’t confirm your cart. Please view your cart to continue.', 'CART_CONFIRMATION_FAILED');
    }
    if (expectedSelection) {
      if (expectedSelection.pending || !Array.isArray(expectedSelection.items) || !expectedSelection.items.length ||
          ['refill', 'one-time'].indexOf(expectedSelection.mode) === -1) {
        throw handoffError('Your pack needs another check. Please view your cart to continue.', 'PACK_CONFIRMATION_FAILED');
      }
      var expected = Object.create(null);
      expectedSelection.items.forEach(function (item) {
        var id = variantId(item.id);
        if (!id || !Number.isSafeInteger(item.quantity) || item.quantity < 0) {
          throw handoffError('Your pack needs another check. Please view your cart to continue.', 'PACK_CONFIRMATION_FAILED');
        }
        expected[id] = (expected[id] || 0) + item.quantity;
      });
      var totalExpected = Object.keys(expected).reduce(function (total, id) { return total + expected[id]; }, 0);
      if (!Number.isSafeInteger(totalExpected) || totalExpected <= 0 ||
          expectedSelection.requiredQuantity != null && expectedSelection.requiredQuantity !== totalExpected) {
        throw handoffError('Your pack needs another check. Please view your cart to continue.', 'PACK_CONFIRMATION_FAILED');
      }
      var expectedPlan = expectedSelection.mode === 'refill' ? REFILL_PLAN_ID : '';
      Object.keys(expected).forEach(function (id) {
        if ((planQuantities[id + ':' + expectedPlan] || 0) < expected[id]) {
          throw handoffError('Your pack needs another check. Please view your cart to continue.', 'PACK_CONFIRMATION_FAILED');
        }
      });
    }
  }

  async function readJson(run, url, options) {
    checkActive(run);
    var response = await window.fetch(url, Object.assign({}, options, { signal: run.controller.signal }));
    checkActive(run);
    var data = await response.json();
    checkActive(run);
    if (!response.ok || !data || typeof data !== 'object') {
      throw handoffError('We couldn’t prepare checkout. Please view your cart to continue.', 'CHECKOUT_SERVICE_UNAVAILABLE');
    }
    return data;
  }

  async function perform(run, options) {
    var configuration = getConfiguration();
    var cart = await readJson(run, configuration.cartUrl, {
      method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
    });
    cartDetails(cart, options.expectedSelection);
    checkActive(run);
    run.navigating = true;
    window.location.assign(configuration.checkoutUrl);
    return { status: 'navigating' };
  }

  function start(options) {
    if (active) return active.promise;
    var run = { controller: new AbortController(), cancelled: false, navigating: false, promise: null };
    active = run;
    var timer;
    var deadline = new Promise(function (_, reject) {
      timer = window.setTimeout(function () {
        run.cancelled = true;
        run.controller.abort();
        reject(handoffError('Checkout took too long. Please view your cart to continue.', 'CHECKOUT_HANDOFF_TIMEOUT'));
      }, TIMEOUT_MS);
    });
    run.promise = Promise.race([perform(run, options || {}), deadline]).catch(function (error) {
      run.cancelled = true;
      run.controller.abort();
      if (active === run) active = null;
      if (error && error.hushCheckoutHandoff) throw error;
      throw handoffError('We couldn’t open checkout. Please view your cart to continue.', 'CHECKOUT_SERVICE_UNAVAILABLE');
    }).finally(function () { window.clearTimeout(timer); });
    return run.promise;
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted && active && active.navigating) {
      // Reload the current cart when returning from checkout instead of keeping
      // a cached pending state or an old cart snapshot.
      window.location.reload();
    }
  });

  window.HushCheckoutHandoff = {
    start: start,
    isPending: function () { return Boolean(active); }
  };
})();
